import {MinusIcon} from '@ui/atoms/icons';
import {GOALS_REFLECTION_PROMPT} from './goals-content';
import {
  AdditionalHint,
  BlockContent,
  BlockDragRail,
  CompatibilityError,
  DragIcon,
  QuestionBlockHeader,
  QuestionBody,
  QuestionCard,
  QuestionTypePill,
  ReadOnlyQuestion,
  RemoveIcon,
  RemoveRow,
} from './content-step.styles';

interface GoalsBlockProps {
  dragHandleProps: any;
  isDragging: boolean;
  incompatible?: boolean;
  onRemove: () => void;
}

export const GoalsBlock = ({
  dragHandleProps,
  isDragging,
  incompatible = false,
  onRemove,
}: GoalsBlockProps) => {
  return (
    <QuestionCard isDragging={isDragging} data-block-type="goals">
      <BlockDragRail {...dragHandleProps} aria-label="Reorder goals">
        <DragIcon aria-hidden="true">⠿</DragIcon>
      </BlockDragRail>
      <BlockContent spacing="default">
        {incompatible && (
          <CompatibilityError role="alert">
            Goals are not compatible with Anonymous visibility. Remove this
            block or change visibility.
          </CompatibilityError>
        )}
        <QuestionBlockHeader>
          <QuestionTypePill variant="goals">Goal reflection</QuestionTypePill>
          <RemoveRow onClick={onRemove} aria-label="Remove goals">
            <RemoveIcon>
              <MinusIcon />
            </RemoveIcon>{' '}
            Remove
          </RemoveRow>
        </QuestionBlockHeader>
        <QuestionBody>
          <ReadOnlyQuestion
            role="textbox"
            aria-readonly="true"
            aria-label="Goals reflection question">
            {GOALS_REFLECTION_PROMPT}
          </ReadOnlyQuestion>
          <AdditionalHint>
            Participants will see their active goals above this question. The
            question cannot be changed.
          </AdditionalHint>
        </QuestionBody>
      </BlockContent>
    </QuestionCard>
  );
};
